import React, { useEffect, useState } from 'react';
import { Card, Tooltip, message, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const GamesList = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGames = async () => {
      setLoading(true); // Set loading to true at the start
      try {
        const access_token = localStorage.getItem('access_token');
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/games/`, {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });
        setGames(response.data);
      } catch (error) {
        message.error('Failed to fetch games');
        console.error('Error fetching games:', error);
      } finally {
        setLoading(false); // Set loading to false when request is complete
      }
    };

    fetchGames();
  }, []);

  const handleGameClick = (game) => {
    navigate(`/dashboard/game/${game.id}/manage-data/player-stats-input-ingame`, { state: { game } });
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', // Define card layout
        gap: '20px', // Spacing between cards
        padding: '80px 20px 20px', // Padding for navbar
        backgroundColor: 'white',
        justifyContent: 'center', // Center the cards
        alignContent: 'start', // Ensure the grid doesn’t stretch vertically
      }}
    >
      {loading ? (
        // Display a centered loading spinner while loading
        <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <Spin size="large" />
        </div>
      ) : (
        games.map((game) => (
          <Tooltip
            title={
              <div style={{ color: '#1890ff' }}>
                <p>
                  Time: 
                  {game.time ? (
                    game.time.split(':').slice(0, 2).join(':') // Extracts HH:mm from HH:mm:ss
                  ) : 'N/A'}
                </p>
                <p>Location: {game.location}</p>
                <p>{game.home_team} Score: {game.home_score !== null && game.home_score !== undefined ? game.home_score : 'N/A'}</p>
                <p>{game.away_team} Score: {game.away_score !== null && game.away_score !== undefined ? game.away_score : 'N/A'}</p>
                <p>Winning Team: {game.winning_team || 'N/A'}</p>
              </div>
            }
            key={game.id}
            overlayInnerStyle={{
              backgroundColor: '#f0f0f0',
              borderRadius: '8px',
              padding: '10px',
            }}
          >
            <Card
              hoverable
              style={{
                width: '250px', // Fixed card width
                height: '180px', // Fixed card height
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
                color: 'white',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              }}
              onClick={() => handleGameClick(game)}
            >
              <h3 style={{ margin: 0 }}>{game.home_team}</h3>
              <h4 style={{ margin: '10px 0' }}>vs.</h4>
              <h3 style={{ margin: 0 }}>{game.away_team}</h3>
              <h5 style={{ marginTop: '10px', color: '#dcdcdc' }}>Click to manage stats</h5>
            </Card>
          </Tooltip>
        ))
      )}
    </div>
  );
};

export default GamesList;
